import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Footer, Header } from '../Common';
import Products from '../../Models/Products';
import {SUCCESS_ALERT} from "../../Action/type";
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class AffiliatorBuyerRequestHome extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('0'))
            this.props.history.push('/login/affiliator');
        };
        // console.log("lllllllllllllllllllllllll: ",props.location);
        if (props.location.state){
            if (props.location.state.flag === SUCCESS_ALERT){
                alert(this.props.t("13"))
                // this.props.location.state.flag = "";
                props.history.replace({
                    ...props.location,
                    state: {
                        ...props.location.state,
                        flag: null
                    }
                });
            }
        }
        this.state = {
            RequestList: [],
            minHeight: "475px"
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        var id = logged_user.id;
        this.getRequestList(id);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    getRequestList(id) {
        Products.getSellerRequest(id).then(res => {
            console.log(res.data)
            this.setState({ RequestList: res.data.payload })
        })
    }
    handleSubmit(e) {
        e.preventDefault();
        let data = {

        }
        console.log(data);
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="input_name big_font" style={{ width: "100%", textAlign: 'left', fontSize: '20px' }}>
                                    {this.props.t('3')}
                                </div>
                                <div style={{ minHeight: "350px", border: "1px solid #ddd", padding: "4%" }}>
                                    <div style={{ padding: "3%" }} className="" >
                                        <div style={{ textAlign: "center", cursor: "pointer" }}>
                                            <Link style={{ textDecoration: "none" }} to={'/affiliator-post-request-buyer'} href="">
                                                <div className="use_request_button category-right " style={{ width: "-webkit-fill-available", marginTop: "0px" }} >
                                                    <div className="seller_button" style={{ marginTop: "2px" }} >
                                                        {this.props.t('1')}
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <br/>
                                    {/* {(() => {
                                        if (this.state.RequestList.length < 1) {
                                            return (
                                                <div></div>
                                            )
                                        } else {
                                            return (
                                                <div className="col-md-12 ">
                                                    <div className="row" style={{ borderBottom: "1px solid #ddd", paddingTop: "3%", paddingBottom: "2%" }}>
                                                        <div className="col-5 font_12">
                                                            {this.props.t('6')}
                                                    </div>
                                                        <div className="col-2 font_12">
                                                            {this.props.t('7')}
                                                    </div>
                                                        <div className="col-3 font_12">
                                                            {this.props.t('12')}
                                                    </div>
                                                        <div className="col-2 font_12">
                                                            {this.props.t('10')}
                                                    </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    })()} */}
                                    {this.state.RequestList.map((req, i = 1) =>
                                        <div className=" " key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                            <div className="font_12 pb-2">
                                                <Link style={{ textDecoration: "none" }} to={{
                                                    pathname: `/affiliator-request-details`,
                                                    state: {
                                                        id: req.id
                                                    }
                                                }}>
                                                    <b>{req.title}</b>
                                                </Link>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 font_12">
                                                    <b>{req.budget_amount}</b>
                                                </div>
                                                <div className="col-6 font_12"style={{textAlign:'right'}}>
                                                    {(JSON.stringify(req.application_date)).substring(1, 11)}
                                                </div>
                                            </div>
                                            <div className="col-md-2 font_12">
                                                <b>{req.number_of_proposals}</b>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            {this.props.t('3')}
                                    </div>
                                        <div style={{ minHeight: "500px", border: "1px solid #ddd", padding: "4%" }}>
                                            <div style={{ padding: "6%", border: "1px solid #ddd" }} className="" >
                                                <div style={{ textAlign: "right", cursor: "pointer" }}>
                                                    <Link style={{ textDecoration: "none" }} to={'/affiliator-post-request-buyer'} href="">
                                                        <div className="use_request_button category-right " style={{ width: "175px", marginTop: "0px", marginLeft: "33%" }} >
                                                            <div className="seller_button text-center" style={{ marginTop: "5px" }} >
                                                                {this.props.t('1')}
                                                        </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                            {(() => {
                                                if (this.state.RequestList.length < 1) {
                                                    return (
                                                        <div></div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="col-md-12 row" style={{ borderBottom: "1px solid #ddd", paddingTop: "3%", paddingBottom: "2%" }}>
                                                            <div className="col-md-5 font_12">
                                                                {this.props.t('6')}
                                                        </div>
                                                            <div className="col-md-2 font_12">
                                                                {this.props.t('7')}
                                                        </div>
                                                            <div className="col-md-3 font_12">
                                                                {this.props.t('12')}
                                                        </div>
                                                            <div className="col-md-2 font_12">
                                                                {this.props.t('10')}
                                                        </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            {this.state.RequestList.map((req, i = 1) =>
                                                <div className="col-md-12 row" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                                    <div className="col-md-5 font_12">
                                                        {/* <span className="font_12">{this.props.t('3')} No: {++i}</span><br /> */}
                                                        <Link style={{ textDecoration: "none" }} to={{
                                                            pathname: `/affiliator-request-details`,
                                                            state: {
                                                                id: req.id
                                                            }
                                                        }}>
                                                            <b>{req.title}</b>
                                                        </Link>
                                                    </div>
                                                    <div className="col-md-2 font_12">
                                                        {(JSON.stringify(req.application_date)).substring(1, 11)}
                                                    </div>
                                                    <div className="col-md-3 font_12">
                                                        <b>{req.budget_amount}</b>
                                                    </div>
                                                    <div className="col-md-2 font_12">
                                                        <b>{req.number_of_proposals}</b>
                                                    </div>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

export { AffiliatorBuyerRequestHome };


 AffiliatorBuyerRequestHome = withTranslation('src_Components_Request_AffiliatorBuyerRequestHome')(AffiliatorBuyerRequestHome);
